import {SODeletePaymentIntent} from '../../core/payment-intent/so-delete-payment-intent';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePaymentIntent extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePaymentIntent;
}